import axios from 'axios';

const baseUrl = process.env.REACT_APP_BACKEND_DOMAIN;

export default class Country {

  static endpoints = {
    index : `${baseUrl}/countries`
  };

  static all() {
    return axios.get(this.endpoints.index).then((response)=> response.data.countries);
  };
}
